module.exports = {"helmetTitle":"Veloe - Editar Representantes legais","title":"Representantes legais","subtitle":"Mantenha as informações dos responsáveis pela sua empresa sempre atualizadas.","modalTitle":"Pronto! A gente já salvou suas alterações. ;)","sameCpfError":"Este CPF já está cadastrado. Tente novamente."}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/EditRepresentatives/data.json
// module id = 1752
// module chunks = 0